var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import ModelTraits from "../ModelTraits";
import primitiveTrait from "../Decorators/primitiveTrait";
export let MinMaxLevelTraits = (_dec = primitiveTrait({
  type: "number",
  name: "Maximum Scale Denominator",
  description: "The denominator of the smallest scale (largest denominator) for which tiles should be requested. " + "For example, if this value is 10000, then tiles representing a scale smaller than 1:10000 (i.e. " + "numerically larger denominator, when zooming out further) will not be requested. For large scales set " + "hideLayerBeforeMaxScaleDenominator to true, otherwise you may experience performance issues (requesting too many tiles)."
}), _dec2 = primitiveTrait({
  type: "number",
  name: "Minimum Scale Denominator",
  description: "The denominator of the largest scale (smallest denominator) for which tiles should be requested. " + "For example, if this value is 1000, then tiles representing a scale larger than 1:1000 (i.e. " + "numerically smaller denominator, when zooming in closer) will not be requested.  Instead, tiles of " + "the largest-available scale, as specified by this property, will be used and will simply get " + "blurier as the user zooms in closer."
}), _dec3 = primitiveTrait({
  type: "boolean",
  name: "Hide Layer After Minimum Scale Denominator",
  description: "True to hide tiles when the `Minimum Scale Denominator` is exceeded. If false, we can zoom in arbitrarily close to the (increasingly blurry) layer."
}), _dec4 = primitiveTrait({
  type: "string",
  name: "Scale workbench info",
  description: "The message to show to the user when this dataset is not visible due to scale."
}), _class = class MinMaxLevelTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "maxScaleDenominator", _descriptor, this);
    _initializerDefineProperty(this, "minScaleDenominator", _descriptor2, this);
    _initializerDefineProperty(this, "hideLayerAfterMinScaleDenominator", _descriptor3, this);
    _initializerDefineProperty(this, "scaleWorkbenchInfo", _descriptor4, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "maxScaleDenominator", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "minScaleDenominator", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "hideLayerAfterMinScaleDenominator", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "scaleWorkbenchInfo", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);